import { CaseData } from '../PageContent'

import { CaseImage } from '../CaseImage'
import { CaseVideo } from '../CaseVideo'

interface LayoutProps {
 data: CaseData
 files: {
  type: string
  src: string
 }[]
}

export function Layout5({ data, files }: LayoutProps) {
 const initialFiles = files.slice(0, 7)
 const finalImages = files.slice(7, 12)

 return (
  <div className="container">
   {initialFiles.map((item, index) =>
    item.type === 'image' ? (
     <div className="flex flex-wrap" key={index}>
      <div
       className="w-full relative mt-2.5"
       data-aos={index % 2 === 0 ? 'fade-left' : 'fade-right'}
      >
       <CaseImage
        imageIndex={index}
        folder={data.cf_client_name}
        image={item.src}
       />
      </div>
     </div>
    ) : (
     <div className="flex flex-wrap" key={index}>
      <div className="w-full pt-2.5" data-aos="fade-right">
       <CaseVideo
        videoIndex={index}
        add="cv1"
        video={item.src}
        className="embed-responsive"
       />
      </div>
     </div>
    )
   )}
   {finalImages.length > 0 && (
    <div className="flex flex-wrap pt-2.5">
     {finalImages
      .filter(item => item.type === 'image')
      .map((item, index) => (
       <div
        className="w-full sm:w-1/2 md:w-1/4 lg:w-1/4 pr-2.5 max-[768px]:pr-0 last:pr-0 mb-4"
        data-aos="fade-left"
        key={`image-${index}`}
       >
        <CaseImage
         add="cv2"
         imageIndex={index + 7}
         folder={data.cf_client_name}
         image={item.src}
        />
       </div>
      ))}

     {finalImages
      .filter(item => item.type === 'video')
      .map((item, index) => (
       <div
        className="w-full sm:w-1/2 md:w-1/4 lg:w-1/4 pr-2.5 max-[768px]:pr-0 last:pr-0 mb-4"
        data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
        key={`video-${index}`}
       >
        <CaseVideo
         videoIndex={index}
         add="cv2"
         video={item.src}
         className="embed-responsive"
        />
       </div>
      ))}
    </div>
   )}
  </div>
 )
}
